import {
    CalendarTodayOutlined,
    DateRangeOutlined,
    DescriptionOutlined,
    LocalOfferOutlined,
} from "@mui/icons-material";
import { Box, Checkbox, Grid, IconButton } from "@mui/material";
import { LabelCompo } from "../../components/Comman/Label";
import TypographyCompo from "../../components/Comman/TypographyCompo";
import { blackColor, darkGrayColor, redColor, titleColor, violetShadeColor } from "../../config/ColorObj";
import offerImg from "../../Images/offer.png";
import OutletList from "./OutletList";

const OfferCard = ({
    offer,
    offerIndex,
    selectedOutlets,
    expandedProductIndex,
    onOutletCheckboxChange,
    onToggleProductRow,
    onSelectAllOutletsForOffer,
    getSelectedOutletsCountForOffer,
}) => {
    const selectedCount = getSelectedOutletsCountForOffer(offerIndex, offer.outlets);
    const allSelected = selectedCount === offer.outlets.length;
    const someSelected = selectedCount > 0 && selectedCount < offer.outlets.length;

    return (
        <div
            style={{
                marginBottom: "10px",
                paddingBottom: "10px",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    padding: "1px",
                    border: "2px solid #ddd",
                    borderRadius: "20px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
            >
                {/* Offer Image */}
                <Box
                    sx={{
                        position: "absolute",
                        top: "8px",
                        right: "30px",
                        width: "70px",
                        height: "60px",
                    }}
                >
                    <img
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15%",
                            objectFit: "contain",
                            padding: "5px",
                        }}
                        src={offerImg}
                        alt="Offer Icon"
                    />
                </Box>

                <Grid container spacing={2} padding={4}>
                    {/* Offer Details */}
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        sx={{ marginLeft: 1 }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <IconButton size="small" disabled>
                                <LocalOfferOutlined sx={{ color: blackColor }} />
                            </IconButton>
                            <LabelCompo
                                className="text-black"
                                style={{
                                    fontSize: 16,
                                    color: titleColor,
                                    marginRight: 8,
                                }}
                                label="Offer Name:"
                            />
                            <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16 }}
                                label={offer?.name || "-"}
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <IconButton size="small" disabled>
                                <DescriptionOutlined sx={{ color: blackColor }} />
                            </IconButton>
                            <LabelCompo
                                className="text-black"
                                style={{
                                    fontSize: 16,
                                    color: titleColor,
                                    marginRight: 8,
                                }}
                                label="Description:"
                            />
                            <LabelCompo
                                className="text-black"
                                style={{
                                    fontSize: 16,
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    whiteSpace: "normal",
                                    maxWidth: "70%",
                                }}
                                label={offer?.description || "-"}
                            />
                        </Grid>
                    </Grid>

                    {/* Date Range */}
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        sx={{ marginTop: 1, marginLeft: 1 }}
                    >
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <IconButton size="small" disabled>
                                <CalendarTodayOutlined sx={{ color: blackColor }} />
                            </IconButton>
                            <LabelCompo
                                className="text-black"
                                style={{
                                    fontSize: 16,
                                    color: titleColor,
                                    marginRight: 8,
                                }}
                                label="From Date:"
                            />
                            <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16 }}
                                label={offer?.fromDate || "-"}
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <IconButton size="small" disabled>
                                <DateRangeOutlined sx={{ color: blackColor }} />
                            </IconButton>
                            <LabelCompo
                                className="text-black"
                                style={{
                                    fontSize: 16,
                                    color: titleColor,
                                    marginRight: 8,
                                }}
                                label="To Date:"
                            />
                            <LabelCompo
                                className="text-black"
                                style={{ fontSize: 16 }}
                                label={offer?.toDate || "-"}
                            />
                        </Grid>
                    </Grid>

                    {/* Outlets Section */}
                    {offer?.outlets?.length > 0 && (
                        <>
                            {/* Select All Outlets Header */}
                            <Box
                                sx={{
                                    mt: 1,
                                    mb: 0,
                                    p: 2,
                                    borderRadius: "12px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <Checkbox
                                    checked={allSelected}
                                    indeterminate={someSelected}
                                    onChange={(e) =>
                                        onSelectAllOutletsForOffer(
                                            offerIndex,
                                            offer.outlets,
                                            offer,
                                            e.target.checked
                                        )
                                    }
                                    sx={{
                                        color: violetShadeColor,
                                        "& .MuiSvgIcon-root": { fontSize: 24 },
                                    }}
                                />
                                <TypographyCompo
                                    sx={{
                                        fontSize: 16,
                                        fontWeight: 600,
                                        color: blackColor,
                                        ml: 1,
                                    }}
                                >
                                    Select All Outlets
                                </TypographyCompo>

                                <Box
                                    sx={{
                                        background: "rgba(255,255,255,0.2)",
                                        backdropFilter: "blur(10px)",
                                        borderRadius: "20px",
                                        padding: "8px 20px",
                                        display: "flex",
                                        gap: 2,
                                    }}
                                >
                                    <TypographyCompo
                                        sx={{ color: darkGrayColor, fontSize: 14, fontWeight: 500 }}
                                    >
                                        <strong>{selectedCount}</strong> / {offer.outlets.length}{" "}
                                        Selected
                                    </TypographyCompo>
                                </Box>

                                {/* Info Note */}
                                <TypographyCompo
                                    sx={{
                                        ml: 1,
                                        fontSize: 13,
                                        fontWeight: 500,
                                        color: redColor,
                                    }}
                                >
                                    ℹ️ Click on an outlet name to see product details
                                </TypographyCompo>
                            </Box>

                            {/* Outlet List */}
                            <OutletList
                                outlets={offer.outlets}
                                offerIndex={offerIndex}
                                offer={offer}
                                selectedOutlets={selectedOutlets}
                                expandedProductIndex={expandedProductIndex}
                                onOutletCheckboxChange={onOutletCheckboxChange}
                                onToggleProductRow={onToggleProductRow}
                                getSelectedOutletsCountForOffer={getSelectedOutletsCountForOffer}
                            />
                        </>
                    )}
                </Grid>
            </Box>
        </div>
    );
};

export default OfferCard;